<nav aria-label="breadcrumb" class="d-flex align-items-center text-dark">
  <!-- Breadcrumb -->
  <ol class="breadcrumb mb-0 align-items-center text-dark">
    <li 
      v-for="(crumb, index) in breadcrumbs" 
      :key="crumb.path" 
      class="breadcrumb-item d-flex align-items-center text-dark"
      :class="{ active: index === breadcrumbs.length - 1 }"
    >
      <router-link 
        v-if="index !== breadcrumbs.length - 1" 
        :to="crumb.path" 
        class=" text-decoration-none fw-semibold text-xs text-dark"
      >
        {{ crumb.label }}
      </router-link>
      
      <span v-else class=" text-xs fw-bold" aria-current="page">
        {{ crumb.label }}
      </span>
    </li>
  </ol>

</nav>
